import { getJson } from "./client";

export interface Leitura {
  tenant_id: string;
  device_id: string;
  tag: string;
  indice: number;
  valor: number;
  timestamp_medicao: string;
}

export interface Ativo {
  id: string;
  tenant_id: string;
  parent_asset_id: string | null;
  nome: string;
  criado_em: string;
  geom: { type: string; coordinates: number[] } | null;
}

export interface Device {
  device_id: string;
  tenant_id: string;
  asset_id: string;
  decoder_profile_id: string | null;
  device_model: string | null;
  criado_em: string;
}

export interface Variavel {
  tag: string;
  nome: string | null;
  unidade: string | null;
  fonte_padrao: string | null;
}

export interface AlertaEvento {
  id: string;
  tenant_id: string;
  device_id: string;
  tag: string;
  indice: number;
  valor: number;
  limite_violado: "inferior" | "superior";
  timestamp_medicao: string;
  criado_em: string;
  reconhecido_em?: string | null;
}

export interface FiltrosLeitura {
  /** Estacoes (asset_id) - filtro primario. Vazio/omitido = todas as estacoes no escopo do usuario. */
  assetIds?: string[];
  /** Devices - filtro secundario, opcional. Vazio/omitido = todos os devices das estacoes selecionadas. */
  deviceIds?: string[];
  /** Variaveis (tag). Vazio/omitido = todas. */
  tags?: string[];
  inicio?: string;
  fim?: string;
  limit?: number;
  /** 'auto': deixa o M5 decidir se agrega (time_bucket) quando inicio+fim cobrem um range largo. */
  agregacao?: "auto";
}

function paraQuery(filtros: Record<string, string | number | undefined>): string {
  const p = new URLSearchParams();
  for (const [chave, valor] of Object.entries(filtros)) {
    if (valor !== undefined && valor !== "") p.set(chave, String(valor));
  }
  const qs = p.toString();
  return qs ? `?${qs}` : "";
}

export function buscarLeituras(f: FiltrosLeitura = {}): Promise<Leitura[]> {
  return getJson(
    "/m5/api/leituras" +
      paraQuery({
        asset_id: f.assetIds?.join(","),
        device_id: f.deviceIds?.join(","),
        tag: f.tags?.join(","),
        inicio: f.inicio,
        fim: f.fim,
        limit: f.limit,
        agregacao: f.agregacao,
      })
  );
}

export function buscarAtivos(): Promise<Ativo[]> {
  return getJson("/m5/api/ativos");
}

export function buscarDevices(): Promise<Device[]> {
  return getJson("/m5/api/devices");
}

export function buscarVariaveis(): Promise<Variavel[]> {
  return getJson("/m5/api/variaveis");
}

export function buscarAlertas(limit = 100): Promise<AlertaEvento[]> {
  return getJson("/m5/api/alertas" + paraQuery({ limit }));
}

/** Tags que as estações informadas já reportaram alguma vez (SELECT DISTINCT
 * de verdade) - diferente de derivar de uma amostra de leituras recentes,
 * que escondia variáveis gravadas com pouca frequência (ex: 1x/dia). */
export function buscarTagsDisponiveis(assetIds: string[] = []): Promise<string[]> {
  return getJson("/m5/api/leituras/tags" + paraQuery({ asset_id: assetIds.join(",") }));
}
